// extracted by mini-css-extract-plugin
export default {"login-container":"ForgotPassword_login-container__tNFWH","login-img":"ForgotPassword_login-img__JAYDg"};